<template>
  <div class="card" data-qa="contract-card" @click="clickFullRow">
    <div class="header">
      <div class="title">
        <h4>{{ company.BusinessName }}</h4>
      </div>
      <match-percentage :percentage="contract.MatchPercentage" />
      <span v-if="contract.isPoIdMatch" class="poid-match" data-qa="customer-id-match-badge">{{
        i18n.t('/FleetContracts/Search/CustomerIdMatch')
      }}</span>
    </div>

    <span>{{ i18n.t('/FleetContracts/Details/CustomerId') }}: </span>
    <span data-qa="contract-customer-company-id">{{ company.CustomerId }}</span>
    <br />

    <address itemscope itemtype="http://schema.org/Organization">
      <div itemprop="address">
        <span v-if="companyAddress" itemprop="streetAddress">{{ companyAddress }}</span>
        <template v-if="showMore">
          <br />
          <span v-if="company.ZipCode" itemprop="postal-code">
            {{ company.ZipCode }}
          </span>
        </template>
        <template v-else>, </template>
        <span v-if="company.City" itemprop="locality">{{ company.City }}</span>
        <br />
        <span>{{ company.Phone }}</span>
      </div>
    </address>

    <span>{{ i18n.t('/FleetContracts/Details/ContractNumber') }}: </span>
    <span
      ><a :href="linkToDap" target="_blank" alt="DAP">{{ contract.ContractNumber }}</a></span
    >

    <fleet-contract-details v-if="showMore" :contract="contract" :show-all-details="false" />

    <div class="buttons">
      <app-button
        button-class="inverted--bordered btn-toggle-details"
        data-qa="toggle-company-details-button"
        @click.prevent.stop="showMore = !showMore"
      >
        {{
          i18n.t(
            showMore ? '/FleetContracts/Search/ShowLessInfo' : '/FleetContracts/Search/ShowMoreInfo'
          )
        }}
      </app-button>
      <app-button
        button-class="primary"
        data-qa="choose-contract-button"
        @click.stop="selectContract"
      >
        {{ i18n.t('/FleetContracts/Search/SelectContract') }}
      </app-button>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import MatchPercentage from '@/components/generic/presentational/atoms/matchPercentage/MatchPercentage.vue'
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'
import FleetContractDetails from '@/components/generic/presentational/molecules/fleetContractDetails/FleetContractDetails.vue'

export default {
  components: {
    AppButton,
    MatchPercentage,
    FleetContractDetails,
  },
  props: {
    contract: {
      type: Object,
      required: true,
    },
  },
  emits: ['selectResult'],
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showMore: false,
    }
  },

  computed: {
    company() {
      return this.contract.CustomerFleetCompany
    },
    companyAddress() {
      return `${this.company.Street} ${this.company.Housenumber}`
    },
    linkToDap() {
      return `${window.VUE_CLI_EXPORTS.settings.DapUrl}${this.contract.ContractNumber}`
    },
  },
  methods: {
    selectContract() {
      this.$emit('selectResult', this.contract)
    },
    clickFullRow(event) {
      this.selectContract()
    },
  },
}
</script>

<style lang="scss" scoped>
.card {
  border: 1px solid $gray-light;
  margin-bottom: $gutter;
  padding: $gutter;
  transition: background-color 0.2s ease-out;
  cursor: pointer;

  &:hover {
    background: #f8f8f8;
  }
}

.header {
  margin-bottom: 0.5em;

  @include breakpoint(md) {
    display: flex;
    align-items: flex-start;
  }
}

.title {
  margin-right: 0.5em;

  h4 {
    display: inline;
  }
}

.buttons {
  display: flex;
  justify-content: space-between;
}

.btn-toggle-details {
  color: inherit;
}

.extra-details {
  display: grid;
  grid-template-columns: 1fr 2fr;
  margin-bottom: 1em;
  column-gap: 6px;
}

.poid-match {
  margin: 0 0 0 0.5rem;
  color: white;
  border-radius: 5px;
  padding: 0 12px;
  background-color: rgba(76, 175, 80, 0.9);
}
</style>
